export default "__VITE_ASSET__JJc3NhEj__"